import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YearLookupComponent } from './year-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
  ],
  declarations: [YearLookupComponent],
  exports: [YearLookupComponent]
})
export class YearLookupModule { }
